var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"table","height":"100%","width":"100%"}},[_c('div',{staticClass:"g-center"},[_c('h1',{staticStyle:{"text-align":"center"}},[_c('p',[_vm._v(" 抱歉! 您的访问权限不足!")])])])])
}]

export { render, staticRenderFns }